import { ExceptionCode } from "@capacitor/core";

/**
 * True when the installed native binary has no implementation for the call —
 * either the whole plugin or the individual method is missing.
 *
 * Both apps load their JS from `server.url`, so a web deploy reaches every
 * installed build instantly while the Swift/Kotlin half of the same change
 * only arrives with a store update. Until that update is adopted, any call
 * added alongside the native change rejects with this code. Treat it as a
 * capability answer ("this build cannot do that"), never as a transient
 * failure to retry.
 */
export function isUnimplementedNativeCall(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    (error as { code?: unknown }).code === ExceptionCode.Unimplemented
  );
}
